import React from 'react'
import { useTranslation } from 'react-i18next'
import { Input, SegmentedControl } from '@components'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { IPaymentDetails } from '@query'
import styled from 'styled-components'

interface RemittanceSectionProps {
  register: UseFormRegister<IPaymentDetails>
  errors: FieldErrors<IPaymentDetails>
  type: 'ref' | 'msg'
  onTypeChange: (type: 'ref' | 'msg') => void
}

export const RemittanceSection: React.FC<RemittanceSectionProps> = ({
  register,
  errors,
  type,
  onTypeChange
}) => {
  const { t } = useTranslation()

  return (
    <Container>
      <SegmentedControl
        value={type}
        onUpdate={onTypeChange}
        options={[
          { value: 'msg', label: t('containers.paymentFormModal.message') },
          { value: 'ref', label: t('containers.paymentFormModal.reference') }
        ]}
      />

      {type === 'ref' && (
        <Input
          label={t('containers.paymentFormModal.reference')}
          errors={errors.reference}
          required
          {...register('reference', {
            required: { value: true, message: t('validation.required') }
          })}
        />
      )}

      {type === 'msg' && (
        <Input
          label={t('containers.paymentFormModal.message')}
          errors={errors.message}
          required
          {...register('message', {
            required: { value: true, message: t('validation.required') }
          })}
        />
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.md}rem;
`
